import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetRolesPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.form-default-values';
import { GetRolesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/inputs/get-roles-paginated.model';
import { useState } from 'react';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterRoleListContextProvider,
  useRoleListContext,
} from '../role.context';
import { RoleListFilterFormController } from './role-list-filter-form/role-list-filter-form.controller';

interface RoleListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const RoleListFilterController = ({
  onCancel,
  onSuccess,
}: RoleListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useRoleListContext();
  const [multiStepFormState] = useState(MultiStepFormState.Default);

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetRolesPaginatedModel> = (errors) => {
    Logger.error(errors);
    toast.error(t('$.role-list-filter.error', { error: t('global.unknown') }));
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<GetRolesPaginatedModel> = (
    fieldValues,
  ) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        customerId: fieldValues.customerId,
        networkId: fieldValues.networkId,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetRolesPaginatedDefaultValues(getPaginatedQueryParameters);

  return (
    <FilterRoleListContextProvider data={data}>
      <RoleListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        state={multiStepFormState}
      />
    </FilterRoleListContextProvider>
  );
};
